document.querySelectorAll('[data-slider]').forEach(function (slideshowEl) {
  if (!slideshowEl.querySelector('[data-slide-type="video"]')) return;

  function getIframePlayer(slide) {
    var container = slide.querySelector('[data-video-player][data-video-type]');
    if (!container) return null;
    var iframe = container.querySelector('iframe');
    if (!iframe) return null;
    return { iframe: iframe, type: container.dataset.videoType };
  }

  function postToIframe(player, vimeoMethod, youtubeFunc) {
    if (!player) return;
    if (player.type === 'youtube') {
      player.iframe.contentWindow.postMessage(
        JSON.stringify({ event: 'command', func: youtubeFunc, args: '' }),
        '*'
      );
    } else if (player.type === 'vimeo') {
      player.iframe.contentWindow.postMessage(
        JSON.stringify({ method: vimeoMethod }),
        '*'
      );
    }
  }

  function syncVideoSlides() {
    var activeSlide = slideshowEl.querySelector('.slideshow__slide.is-selected');
    slideshowEl.querySelectorAll('[data-slide-type="video"]').forEach(function (slide) {
      var video = slide.querySelector('video');
      var iframePlayer = getIframePlayer(slide);
      if (slide === activeSlide) {
        if (video) video.play().catch(function () {});
        if (iframePlayer) postToIframe(iframePlayer, 'play', 'playVideo');
      } else {
        if (video) { video.pause(); video.currentTime = 0; }
        if (iframePlayer) postToIframe(iframePlayer, 'pause', 'pauseVideo');
      }
    });
  }

  // Watch for Flickity slide changes via is-selected class mutations
  var classObserver = new MutationObserver(syncVideoSlides);
  slideshowEl.querySelectorAll('.slideshow__slide').forEach(function (slide) {
    classObserver.observe(slide, { attributes: true, attributeFilter: ['class'] });
  });

  // Watch for VideoBackground inflating <template> into <video> for off-screen slides.
  // Without this, a non-active video slide within 300px rootMargin would autoplay silently.
  slideshowEl.querySelectorAll('video-background').forEach(function (vb) {
    new MutationObserver(function () {
      syncVideoSlides();
    }).observe(vb, { childList: true });
  });

  // Pause/play/mute/unmute button handling for iframe videos
  slideshowEl.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-action]');
    if (!btn) return;
    var slide = btn.closest('[data-slide-type="video"]');
    if (!slide) return;
    var player = getIframePlayer(slide);
    if (!player) return;
    var action = btn.dataset.action;
    if (action === 'pause') postToIframe(player, 'pause', 'pauseVideo');
    else if (action === 'play') postToIframe(player, 'play', 'playVideo');
    else if (action === 'mute') postToIframe(player, 'setVolume', 'mute');
    else if (action === 'unmute') postToIframe(player, 'setVolume', 'unMute');
  });
});
